import {z} from "zod";

const schema = z.object({
	id: z.string().nullable().optional().default(""),
	name: z.string().nullable().optional().default(""),
	accessible: z.boolean().nullable().optional().default(false)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxCorporationNameModel = {schema, model};
export type ITaxCorporationNameModel = z.infer<typeof TaxCorporationNameModel.model>;
export const DEFAULT_TAX_CORPORATION_NAME: ITaxCorporationNameModel = {
	id: "",
	name: "",
	accessible: false
};
